export enum AttenceStateEnum {
    ATTENCE       = 0,  //出勤
	ABSENCE       = 1,  //缺勤
	LATE          = 2,  //迟到
	PLEASE        = 3,  //请假
	PRIVATE_LEAVE = 4,  //事假
	SICK_LEAVE    = 5,  //病假
	STATUTORY     = 6,  //公假
	LEAVE_EARLY   = 7,  //早退
	WAIT_CHECK_IN = 100,//待签到
}